module.exports = __webpack_public_path__ + "img/edgar.4bd281e2.png";